import { render, staticRenderFns } from "./Typeofrequisition.vue?vue&type=template&id=ec68878c&scoped=true&"
import script from "./Typeofrequisition.vue?vue&type=script&lang=js&"
export * from "./Typeofrequisition.vue?vue&type=script&lang=js&"
import style0 from "./Typeofrequisition.vue?vue&type=style&index=0&id=ec68878c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec68878c",
  null
  
)

export default component.exports